import React, { memo } from "react";
import InfoIconBase from "../../../InfoIcon";
import IconSrc from "icons/info.svg";

const InfoIcon = (props) => {
  return <InfoIconBase icon={IconSrc} {...props} />;
};

export default memo(InfoIcon);
